import { preventDoubleClick } from '../global/_doubleClick';
import { setCookieOrWebStorage } from '../global/_cookies';
import { updateHeaderShoppingBagCounts } from '../international/_intl';
export var ajaxRegistryItemAddToCart = function (params, returnHTML) {
	var scrollPosition = null;
	function myCallback() {
		scrollPosition = document.documentElement.scrollTop + 'px';
		if ($('.desktopPage').length == 0) {
			if ($('.mobilePage').length == 0) {
				setCookieOrWebStorage('sessionStorage', 'modalPos', $(document).scrollTop());
			}
			$('body').css({
				position: 'fixed',
				transform: 'translateY(-' + scrollPosition + ')',
				width: '100%',
			});
		}
		preventDoubleClick();
		var form = $('#' + params.formName);
		var imageForAddToModal = form.parents('.product-wrapper').find('.productImage').attr('src');
		$('.add-to-modal-image').attr('src', imageForAddToModal);
		Dillards.setAkamaiWait('02140');
		updateHeaderShoppingBagCounts();

		if ($('.closeATB').length == 1) {
			$('.close').hide();
			$('.modal-title').hide();
			$('.modal-header').hide();
			$('.modal-body').addClass('modal-body-ATB');
		}
		if ($('.modal-title-ATB').length == 1 && $('.outOfStock').length == 0) {
			//Picks the phrase for Add To Bag
			var atbPhrases = ['We like your style!', "You've got great taste!", 'Excellent Choice!'];
			var atbNum = Math.floor(Math.random() * 3);
			var usePhrase = atbPhrases[atbNum];
			$('.modal-title-ATB').text(usePhrase);
		}
	}
	if (params.formName) {
		var form = $('#' + params.formName);
		if (form.find('input[name=sku_1]').val() != '') {
			$.ajax({
				url: '/webapp/wcs/stores/servlet/RegistryFindAddToCart',
				cache: false,
				type: 'POST',
				data: form.serialize(),
				success: function (html) {
					$('.modal-body').addClass('modal-scroll');
					if (typeof returnHTML == 'function') returnHTML(html, myCallback);
					else {
						$('.modal-body').html(html);
						myCallback();
					}
					if (html.search('<strong>0</strong>') > 0) $('#ModalLabel').html('Item(s) not in stock.');
					if ($('.desktopPage').length == 0) {
						$('.modal').css({
							top: scrollPosition,
							'z-index': '2000',
						});
					}
					return false;
				},
			});
		}
	}
};
